/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgIosShare = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M21 22H3V9h4v2H5v9h14v-9h-2V9h4zm-8-6h-2V5.8L8.2 8.6 6.8 7.2 12 2l5.2 5.2-1.4 1.4L13 5.8z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgIosShare as IosShare };
